import type { ChainConfig } from "../config/chains";
import { ChainIdEnum } from "../enums/chain";

export const getSpotDomainName = (config: ChainConfig): string =>
  config.contracts.perpetualDex?.spotDomainName ||
  (config.chainId === ChainIdEnum.MONAD_TESTNET ? "CLOBEngine" : "CLOBRouter");

export const getPerpDomainName = (config: ChainConfig): string =>
  config.contracts.perpetualDex?.perpDomainName ||
  (config.chainId === ChainIdEnum.MONAD_TESTNET ? "PerpEngine" : "CLOBPerpetualRouter");

export const getGaslessPerpRouter = (config: ChainConfig): string | undefined => {
  const dex = config.contracts.perpetualDex;
  if (config.chainId === ChainIdEnum.MONAD_TESTNET) {
    return dex?.perpRouter || dex?.orderHandler;
  }
  return dex?.gaslessPerpRouter;
};
